import * as React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { languageCodes, languages } from "../utils/language";

export const LanguageSelector = ({
    availableLanguages = [],
    margin = `normal`,
    selected,
    setSelected,
    ...props
}) => {
    const languageOptions =
        availableLanguages.length > 0 ? availableLanguages : languageCodes;
    const handleSelect = (event, value) => {
        // It's not a proper Select element so we're not using event.target.value
        if (value === null) {
            setSelected(false);
        } else {
            setSelected(value);
        }
    };
    React.useEffect(() => {
        if (!languageOptions.includes(selected)) {
            setSelected(languageOptions[0]);
        }
    }, [languageOptions, selected, setSelected]);

    return (
        <Autocomplete
            autoComplete
            autoSelect
            disableClearable
            disabled={languageOptions.length === 1}
            getOptionLabel={(option) => languages[option].name}
            id="language-selector"
            onChange={handleSelect}
            options={languageOptions}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    label="Language"
                    margin={margin}
                    variant="outlined"
                />
            )}
            style={{ minWidth: 200 }}
            value={selected}
            {...props}
        />
    );
};
